<template>
<div>
    <div class="form-row" v-if="( mode != 'view' ) && ( mode != 'ocultado' ) && !imprimindo">
      <div class="col col-12 col-md-6" v-if="mode != 'fixed'">
        <template v-if="!config && modelos && modelos.length">
            <div class="small text-muted" v-if="!editar_modelo">
                <button type="button" class="btn btn-link btn-sm text-primary mr-2" title="Editar Modelo" @click="editar_modelo = !editar_modelo">
                    <i class="fa-solid fa-pen"></i>
                </button>
                <span>{{ modelo ? modelo.st_modelo_prontuario : '' }}</span>
            </div>
            <div class="input-group input-group-sm mb-1" v-else>
                <select class="form form-control" v-model="modelo" @change="selecionarModelo ()">
                    <option
                        :value="item"
                        v-for="(item, index) in modelos"
                        :key="index"
                    >{{ item.search }}</option>
                </select>
                <div class="input-group-append" v-if="tipo_consulta">
                    <!-- @click="$emit('modeloPadrao', modelo.id_modelo_prontuario)"> -->
                    <button
                        class="btn"
                        type="button"
                        id="button-addon1"
                        :disabled="!modelo"
                        :class="modelo && ( modelo.id_modelo_prontuario == padrao ) ? 'btn-outline-success' : 'btn-outline-secondary'"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="modelo && ( modelo.id_modelo_prontuario == padrao ) ? 'Modelo padrão para consulta ' + tipo_consulta_nome : 'Definir como modelo padrão para consulta ' + tipo_consulta_nome"
                        @click="changeModeloPadraoMedico(modelo)"
                    >
                        <i class="fas fa-clipboard-check"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Buscar informações do atendimento anterior"
                        @click="herdarAnterior()"
                    >
                        <i class="far fa-copy"></i>
                    </button>
                </div>
                <div class="input-group-append" v-else-if="value && value.id_anamnese">
                    <button
                        class="btn"
                        type="button"
                        id="button-addon1"
                        :disabled="!modelo"
                        :class="modelo && ( modelo.id_modelo_prontuario == padrao ) ? 'btn-outline-success' : 'btn-outline-secondary'"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="modelo && ( modelo.id_modelo_prontuario == padrao ) ? 'Modelo padrão para o procedimento' : 'Definir como modelo padrão para o procedimento'"
                        @click="changeModeloPadraoMedico(modelo)"
                    >
                        <i class="fas fa-clipboard-check"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Buscar informações do atendimento anterior"
                        @click="herdarAnterior()"
                    >
                        <i class="far fa-copy"></i>
                    </button>
                </div>

                <!-- Troca para Laudo -->
                <div class="input-group-append" v-else-if="value && id_procedimento">
                    <button
                        class="btn"
                        type="button"
                        id="button-addon1"
                        :disabled="!modelo"
                        :class="modelo && ( modelo.id_modelo_prontuario == padrao ) ? 'btn-outline-success' : 'btn-outline-secondary'"
                        data-toggle="tooltip"
                        data-placement="top"
                        :title="modelo && ( modelo.id_modelo_prontuario == padrao ) ? 'Modelo padrão para o procedimento' : 'Definir como modelo padrão para o procedimento'"
                        @click="changeModeloPadraoMedicoProcedimento(modelo)"
                    >
                        <i class="fas fa-clipboard-check"></i>
                    </button>

                    <button
                        v-if="id_laudo"
                        type="button"
                        class="btn btn-outline-secondary"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Buscar informações do atendimento anterior"
                        @click="herdarLaudoAnterior()">
                        <i class="far fa-copy"></i>
                    </button>

                    <button
                        v-else
                        type="button"
                        class="btn btn-outline-secondary"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Buscar informações do atendimento anterior"
                        @click="herdarAnterior()">
                        <i class="far fa-copy"></i>
                    </button>
                </div>
            </div>
        </template>
      </div>

      <div class="col col-12 col-md-6 text-right" v-if="mode != 'fixed'">
        <span v-if="!config">
          <span class="text-success ml-1" v-if="saved" title="Salvo">
            <i class="fas fa-check-circle"></i>
          </span>
          <span class="text-secondary ml-1" v-else title="Não Salvo">
            <i class="fas fa-play-circle"></i>
          </span>
          <template v-if="!block_print">
            <button type="button" class="btn btn-link btn-sm ml-2 text-success" v-if="saved">
              <i class="fas fa-print" @click="$emit('imprimirAnamnese', value)"></i>
            </button>
            <span type="button" class="text-muted btn btn-link btn-sm ml-2" v-else>
              <i class="fas fa-print" style="cursor:default;"></i>
            </span>
          </template>
          <slot name="botoes"></slot>
        </span>
        <button type="button" class="btn btn-link btn-sm" @click="editarFormulario ()">
          <i class="fas fa-cog" v-if="!layout_impressao || !layout_impressao.length"></i>
          <i class="fa fa-cogs" v-else></i>
        </button>
      </div>
    </div>

    <div class="row" v-if="( mode == 'view' ) && view_with_print && !imprimindo">
      <div class="col col-8">
        <a href="#" @click.prevent="comprimido = !comprimido" v-if="show_hide">
          <i class="fa fa-minus-square-o fa-fw" aria-hidden="true" v-if="!comprimido"></i>
          <i class="fa fa-plus-square-o fa-fw" aria-hidden="true" v-else></i>
        </a>

        <span class="small text-primary ml-2" v-if="modelo_prontuario && modelo_prontuario.st_modelo_prontuario">{{ modelo_prontuario.st_modelo_prontuario }}</span>
      </div>
      <div class="col col-4 text-right">
        <button type="button" class="btn btn-link btn-sm ml-2 text-success">
          <i class="fas fa-print" @click="$emit('imprimirAnamnese', value)"></i>
        </button>

        <slot name="botoes"></slot>
      </div>
    </div>

    <!-- Formulário -->
    <div v-show="!comprimido && mode != 'ocultado'">
      <div style2="( gutters ? '' : 'max-width: 1140px; ' )" v-if="value && value.length">
        <campos-formulario 
          :show_boxes="show_boxes"
          :infopaciente="infopaciente"
          :tamanho="tamanho"
          :tamanhoform="tamanhoform"
          :gutters="gutters"
          :onecol="onecol"
          :validate="validate"
          v-model="value" 
          :secundario="secundario" 
          :textos="textos" 
          :mode="mode" 
          :raiz="true" 
          :printing="printing" 
          :compact="compact"
          :saved="saved"
          :modelo="modelo_prontuario" />
      </div>

      <div v-else>
        <az-empty-state
          :method="editarFormulario"
          :msg="mode == 'print' ? 'Layout de Impressão Vazio' : 'Formulário Vazio'"
          :icon="mode == 'print' ? 'fas fa-print' : 'fas fa-cog'"
          action="Incluir Campos"
        />
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      :id="config_modal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static" 
      data-keyboard="false"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="mode != 'view'"
    > 
      <div class="modal-dialog modal-xl modal-dialog-total modal-dialog-scrollable" role="document">
        <div class="modal-content modal-content-total">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ mode == 'print' ? 'Layout de Impressão' : 'Formulário' }}</h5>
            <button type="button" class="close" @click="fechar(config_modal)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <campos-config-formulario 
              v-model="formulario" 
              :validate="validate"
              :mode="mode" 
              :base="base" 
              :enquete="enquete"
              :campocustompaciente="campocustompaciente"
              :transferencia="transferencia"
              @recortar="recortar"  />
            <br><br><br><br><br>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <div>
              <button type="button" class="btn btn-primary mr-2" @click="incluirCampo ()" data-toggle="tooltip" data-placement="top" title="Incluir Campo">
                <i class="fas fa-plus"></i>
              </button>
              <button class="btn btn-outline-primary mr-2" type="button" @click="download()" data-toggle="tooltip" data-placement="top" title="Download">
                <i class="fas fa-download"></i>
              </button>
              <button class="btn btn-outline-primary mr-2" type="button" @click="upload()" data-toggle="tooltip" data-placement="top" title="Upload">
                <i class="fas fa-upload"></i>
              </button>
              <button class="btn btn-outline-primary" type="button" @click="upload(true)" data-toggle="tooltip" data-placement="top" title="Upload adicionando os campos">
                <i class="fa-solid fa-file-circle-plus"></i>
              </button>
              
            </div>
            <div>
              <button type="button" class="btn btn-secondary mr-2" @click="fechar(config_modal)">Fechar</button>
              <button type="button" class="btn btn-success" @click="atualizarFormulario ()">Atualizar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Fim Modal -->

    <!-- Modal de Troca de Modelo -->
    <div
      class="modal fade"
      :id="trocar_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Alterar Modelo</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4>Confirma a alteração do modelo de anotações?</h4>

            <div>
              <small class="text-muted">Todos os dados já preenchidos serão perdidos.</small>
            </div>

            <div class="input-group mt-3">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <input type="checkbox" aria-label="Checkbox for following text input" v-model="manter_campos">
                </div>
              </div>
              <label class="form-control">Manter dados de campos com o mesmo "id"</label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-success" @click="trocarModelo ()">Confirmar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Troca de Modelo -->
    <div
      class="modal fade"
      :id="anterior_modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Atendimento Anterior</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-empty-state v-if="!anterior" />
            <template v-else>
              <h4>Confirma buscar os dados do atendimento anterior?</h4>
              <div>
                <small class="text-muted">Todos os dados já preenchidos nesse atendimento serão perdidos</small>
              </div>

              <div class="alert alert-info mt-3" v-if="anterior && anterior.atendimento_procedimento && anterior.atendimento_procedimento.atendimento">
                <div class="d-flex justify-content-between">
                  <div>#{{ anterior.atendimento_procedimento.id_atendimento }}</div>
                  <div>{{ $util.getFormatDate(anterior.atendimento_procedimento.atendimento.dt_inicio)}}</div>
                </div>
                <div v-if="anterior.atendimento_procedimento.procedimento">{{ anterior.atendimento_procedimento.procedimento.search }}</div>
                <div v-if="anterior.atendimento_procedimento.atendimento.medico" class="small">{{ anterior.atendimento_procedimento.atendimento.medico.search }}</div>
              </div>

              <template v-if="!anterior.herdar_completo">
                <az-input
                  v-if="false"
                  class="mt-3"
                  type="checkbox-group"
                  label="Herdar Todos os Campos" 
                  v-model="herdar_todos" />

                <button type="button" class="btn btn-outline-primary btn-sm my-1" @click="toggle_herdar_todos()">Todos</button>

                <div v-for="(campo, icx) in anterior.st_layout_impressao" :key="icx">
                  <az-input
                    type="checkbox-group"
                    :label="campo.campo" 
                    :edicao="( campo.id || campo.campo ) ? true : false"
                    v-model="campo.herdar" />
                </div>

                <pre v-if="false && anterior">{{ anterior }}</pre>
              </template>

              
            </template>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-success" :disable="$store.state.loading"
              @click="confirmarHerdar ()">Confirmar</button>
          </div>
        </div>
      </div>
    </div>

</div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";

import AzEmptyState from "../../util/AzEmptyState.vue";
import CamposFormulario from './CamposFormulario.vue';
import CamposConfigFormulario from './CamposConfigFormulario.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
  data() {
    return {
      comprimido: false, 
      formulario: [],
      modelos: [],
      modelo: null,
      perfil: null,
      padrao: null,
      tipo_consulta_nome: "",
      anterior: null,
      textos: null,
      transferencia: null,  
      manter_campos: this.$util.getCookie('frm-mc') == 'S' ? true : false, 
      editar_modelo: true, 
      estrutura: [
        {
          type: "title",
          label: "Dados Principais",
          width: "12"
        },
        {
          type: "textarea",
          width: "8",
          label: "Histórico Familiar",
          value: "abcde"
        },
        {
          type: "title",
          label: "Outras Informações",
          width: "12"
        },
        {
          type: "text",
          width: "4",
          label: "A"
        },
        {
          type: "text",
          width: "4",
          label: "B"
        },
        {
          type: "select",
          width: "4",
          label: "C",
          data: "id",
          display: "search",
          mode: "json",
          options: [
            { id: 1, search: "abc" },
            { id: 2, search: "def" }
          ]
        }
      ]
    };
  },

  components: {
    AzEmptyState,
    CamposFormulario, 
    CamposConfigFormulario,
    AzInput
  },

  props: [
    "validate", 
    "value",
    "saved",
    "mode",
    "modeloPadrao",
    "config",
    "tipo_consulta",
    "padrao_procedimento",
    "id_procedimento",
    "base", 
    "printing",
    "layout_impressao",
    "compact",
    "id_atendimento",
    "id_atendimento_procedimento", 
    "secundario",
    "gutters",
    "tamanho",
    "tamanhoform",
    "view_with_print",
    "onecol",
    "infopaciente", 
    "campocustompaciente",
    "block_print",
    "block_modelos",
    "show_hide",
    "imprimindo", 
    "enquete",
    "modelo_prontuario", 
    "is_preatendimento",
    "id_laudo", 
    "show_boxes", 
  ],

  watch: {
    value: function(newValue) {
      this.$emit("input", newValue);
    },

    padrao_procedimento: function() {
      if (!this.tipo_consulta) this.padrao = this.padrao_procedimento;
      else this.definir_padrao_pelo_perfil();

      this.$nextTick(() => {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },

    mode: function(newValue, oldValue) {
        console.log('mode', newValue, oldValue);

        if ( oldValue == 'view' && newValue == 'edit' && ( this.textos === null ) ) { 
            this.load_info(); 
        }
    }

  },

  computed: { 
    trocar_modal: function () { 
      return 'trocarModeloModal' + this.id_procedimento + '-' + this.id_atendimento_procedimento;
    },

    config_modal: function () { 
      return 'formularioConfigModal-' + this.mode + '-' + this.id_procedimento + '-' + this.id_atendimento_procedimento;
    },

    anterior_modal: function () { 
      return 'anteriorModal-' + this.mode + '-' + this.id_procedimento + '-' + this.id_atendimento_procedimento;
    },

    /*
    herdar_todos: { 
      get() { 
        if ( !this.anterior )
          return false;

        return !this.anterior.st_layout_impressao.find(item => !item.herdar);
      },
      set(marca) { 
        this.anterior.st_layout_impressao.forEach(item => item.herdar = marca);
      }
    }
    */
  },

  methods: {
    aplicar_modelo (modelo, callback = null) { 
        if ( modelo && modelo.id_modelo_prontuario ) { 
            let destino = this.modelos.find(m => m.id_modelo_prontuario === modelo.id_modelo_prontuario);
            if (destino) {
                this.modelo = destino; 

                if ( callback ) { 
                    this.$nextTick(() => { 
                        callback();
                    });
                }
                this.trocarModelo();
                return;         
            }
        }

        this.modelo = modelo;
        this.trocarModelo();
    },

    toggle_herdar_todos () { 
      if ( !this.anterior )
        return;

      let marca = this.anterior.st_layout_impressao.find(item => !item.herdar) ? true : false;

      this.anterior.st_layout_impressao.forEach(item => item.herdar = marca);
    },

    fechar(modal) {
      $('#' + modal).modal('hide');
    },

    recortar(campo) { 
      this.transferencia = campo;
    },

    verificar_campos_herdados_2(campos) { 
      if ( !campos ) { 
        return [];
      }

      let dados_heranca = {};

      campos.map(campo => { 
        if ( campo.type == 'group' || campo.type == 'tabela' ) { 
          this.verificar_campos_herdados_2(campo.campos);
        } else if ( campo.id ) { 
          if ( this.anterior.st_layout_impressao.find(teste => teste.id == campo.id && teste.herdar) ) { 
            dados_heranca[campo.id] = campo.value;
          }
        } else if ( campo.label ) { 
          if ( this.anterior.st_layout_impressao.find(teste => teste.campo == campo.label && teste.herdar) ) { 
            dados_heranca[campo.label] = campo.value;
          }
        }

        return campo;
      });

      this.preencher_campos(this.value, dados_heranca);
    },
    
    verificar_campos_herdados(campos) { 
      if ( !campos ) { 
        return [];
      }

      return campos.map(campo => { 
        if ( campo.type == 'group' || campo.type == 'tabela' ) { 
          this.verificar_campos_herdados(campo.campos);
        } else { 
          //if ( !campo.label ) { 
          //  campo.value = "";
          //} else { 
            if ( this.anterior.st_layout_impressao.find(teste => teste.campo == campo.label && !teste.herdar) ) { 
              campo.value = "";
            }
          //}
        }

        return campo;
      });
    },

    confirmarHerdar() { 
      if ( this.anterior.herdar_completo ) { 
        this.value = _.cloneDeep(this.anterior.dados);
      } else { 
        this.verificar_campos_herdados_2(this.anterior.dados);
      }

      this.$emit("input", _.cloneDeep(this.value));
      $('#' + this.anterior_modal).modal('hide');
    },

    herdarLaudoAnterior () { 
      this.anterior = null;
      $('[data-toggle="tooltip"]').tooltip('dispose');

      this.$store.commit('loading', true);

      $('#' + this.anterior_modal).modal('show');

      this.$util.loadItem(this, { 
        service: 'pep',
        func: 'laudo_anterior',
        parms: { 
          id_atendimento: this.id_atendimento,
          id_procedimento: this.id_procedimento,
          id_modelo_prontuario: this.modelo ? this.modelo.id_modelo_prontuario : -1, 
          id_laudo: this.id_laudo,
          selecao: true, 
        }
      })
      .then(res => { 
        this.anterior = res;
      })
      .finally(() => { 
        this.$store.commit('loading', false);
      });
    },

    herdarRegistroAnterior () { 
      this.anterior = null;
      $('[data-toggle="tooltip"]').tooltip('dispose');

      this.$store.commit('loading', true);

      $('#' + this.anterior_modal).modal('show');

      this.$util.loadItem(this, { 
        service: 'pep',
        func: 'registro_anterior',
        parms: { 
          id_atendimento: this.id_atendimento,
          id_procedimento: this.id_procedimento,
          id_modelo_prontuario: this.modelo ? this.modelo.id_modelo_prontuario : -1, 
          selecao: true, 
        }
      })
      .then(res => { 
        this.anterior = res;
      })
      .finally(() => { 
        this.$store.commit('loading', false);
      });
    },

    herdarAnterior () { 
      this.anterior = null;
      $('[data-toggle="tooltip"]').tooltip('dispose');

      this.$store.commit('loading', true);

      $('#' + this.anterior_modal).modal('show');

      this.$util.loadItem(this, { 
        service: 'pep',
        func: 'anamnese_anterior',
        parms: { 
          id_atendimento: this.id_atendimento,
          id_procedimento: this.id_procedimento,
          id_modelo_prontuario: this.modelo ? this.modelo.id_modelo_prontuario : -1, 
          selecao: true, 
        }
      })
      .then(res => { 
        this.anterior = res;
      })
      .finally(() => { 
        this.$store.commit('loading', false);
      });
    },

    upload(adicionar = false) { 
      $('[data-toggle="tooltip"]').tooltip('hide');

      var downloadAnchorNode = document.createElement('input');
      downloadAnchorNode.setAttribute("type", "file");
      downloadAnchorNode.setAttribute("class", "d-none");
      downloadAnchorNode.onchange = () => { this.posUpload(downloadAnchorNode, adicionar); };
      document.body.appendChild(downloadAnchorNode); 
      downloadAnchorNode.click();
    },

    posUpload(el, adicionar = false) { 
      var file = el.files[0];

      if (file) {

        var reader = new FileReader();
        
        reader.readAsText(file, "UTF-8");
        
        reader.onload = (evt) => {
          this.$util.loadItem(this, { 
            service: 'modelos',
            func: 'valid',
            parms: { 
              json: evt.target.result,
            }
          })
          .then(res => { 
            if ( adicionar ) { 
              this.formulario = this.formulario.concat(res);
            } else { 
              this.formulario = res;
            }
          });
        }

        reader.onerror = function () {
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Falha lendo arquivo.",
            life: 3000
          });
        }

      }
    },
    
    download () { 
      $('[data-toggle="tooltip"]').tooltip('hide');
      
      var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.value));
      var downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href",     dataStr);
      downloadAnchorNode.setAttribute("download", "modelo.json");
      document.body.appendChild(downloadAnchorNode); 
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },

    definir_padrao_pelo_perfil() {
      switch (this.tipo_consulta) {
        case "I":
          this.padrao = this.perfil.id_modelo_padrao_inicial;
          this.tipo_consulta_nome = "inicial";
          break;

        case "S":
          this.padrao = this.perfil.id_modelo_padrao_subsequente;
          this.tipo_consulta_nome = "subsequente";
          break;

        case "R":
          this.padrao = this.perfil.id_modelo_padrao_revisao;
          this.tipo_consulta_nome = "revisão";
          break;

        default:
          this.padrao = this.padrao_procedimento;
          this.tipo_consulta_nome = "";
          break;
      }
    },

    lista(campo) {
      let lista = [];

      if (campo.type == "select" && campo.options) {
        lista = campo.options.split(",").map(item => {
          return { id: item.trim(), search: item.trim() };
        });
      }

      return lista;
    },
    selecionarModelo() {
      if (this.modelo) {
        $("#" + this.trocar_modal).modal("show");
      }
    },
    trocarModelo() {
        if ( !this.modelo ) { 
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Falha ao carregar modelo. (D)",
                life: 3000
            });
            return; 
        }

        let destino = _.cloneDeep(this.modelo.estrutura);

        if ( !destino ) { 
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Falha ao carregar modelo. (E)",
                life: 3000
            });
            return; 
        }

        if ( this.manter_campos && this.value ) { 
            let valores = this.obter_campos(this.value);
            destino = this.preencher_campos(destino, valores);
        }

        this.$util.setCookie('frm-mc', this.manter_campos ? 'S' : 'N');

        if ( destino && Array.isArray(destino) ) { 
            
            destino = destino.map(campo => { 
                if ( !campo.value || campo.value == 'undefined' ) { 
                    campo.value = "";
                }

                return campo;
            });

        }

        this.$emit("input", destino);
        this.$emit("changeModelo", this.modelo);
        $("#" + this.trocar_modal).modal("hide");
    },

    obter_campos (campos) { 
      let valores = {};

      if ( campos ) { 

        campos.forEach(campo => { 
          if ( campo.type == 'label' ) { 
            //
          } else if ( campo.type == 'group' || campo.type == 'tabela' ) { 
            let outros = this.obter_campos(campo.campos);
            valores = _.merge(valores, outros);
          } else if ( campo.id && campo.value ) { 
            valores[campo.id] = campo.value;
          }
        });

      }

      return valores;
    },

    preencher_campos(modelo, valores) { 
      if ( !modelo ) { 
        return [];
      }

      modelo = modelo.map(campo => { 
        if ( campo.type == 'group' || campo.type == 'tabela' ) { 
          this.preencher_campos(campo.campos, valores);
        } else if ( campo.id ) {
          if ( valores[campo.id] || valores[campo.id] === 0 || valores[campo.id] === "0" ) { 
            campo.value = valores[campo.id];
          }
        } else if ( campo.label ) {
          if ( valores[campo.label] || valores[campo.label] === 0 || valores[campo.label] === "0" ) { 
            campo.value = valores[campo.label];
          }
        }

        return campo;
      });

      return modelo;
    },

    editarFormulario() {
      this.formulario = _.cloneDeep(this.value);
      $("#" + this.config_modal).modal("show");
    },

    atualizarFormulario() {
      this.$emit("input", _.cloneDeep(this.formulario));
      this.$emit("atualizar");
      //this.value = _.cloneDeep(this.formulario);
      $("#" + this.config_modal).modal("hide");
    },

    incluirCampo() {
      $('[data-toggle="tooltip"]').tooltip('hide');

      if ( !this.formulario ) 
        this.formulario = [];
        
      this.formulario.push({
        type: "text",
        color: "", 
        width: "12",
        id:  "",
      });
    },

    excluirCampo(index) {
      this.formulario.splice(index, 1);
    },

    calc_computed() {
      this.value.forEach(campo => {
        if (campo.type == "computed") {
          let calc = this.replace_hashtags(campo.expression);
          if (calc) {
            try {
              let valor = Function('"use strict";return (' + calc + ")")();

              if (campo.precision) {
                let formatter = new Intl.NumberFormat("pt-Br", {
                  style: "decimal",
                  maximumFractionDigits: 2
                });

                //minimumFractionDigits: 2, maximumSignificantDigits: 2,

                campo.value = formatter.format(valor);
              } else {
                campo.value = valor;
              }
            } catch (e) {
              campo.value = "";
              if (e instanceof SyntaxError) {
                console.log(e.message);
              }
            }
          }
        }
      });
    },

    replace_hashtags(expression) {
      var regex = /(?:^|\s)(?:#)([a-zA-Z\d]+)/gm;
      var matches = [];
      var match;

      while ((match = regex.exec(expression))) {
        matches.push(match[1]);
      }

      matches.forEach(hash => {
        let campo = this.value.find(c => {
          return c.id == hash;
        });

        if (campo) {
          expression = expression.replace("#" + hash, campo.value);
        }
      });

      return expression;
    },

    changeModeloPadraoMedicoProcedimento(modelo) {

      this.$util.atualizar(this, {
        service: "medicos",
        func: 'atualizar_modelo_proc',
        dados: { 
          id_procedimento: this.id_procedimento, 
          id_modelo_prontuario: modelo.id_modelo_prontuario,
          id_atendimento: this.id_atendimento, 
        },
        callback: () => {
          this.padrao = modelo.id_modelo_prontuario;

          this.$toast.add({
            severity: "success",
            summary: "Atenção",
            detail: "Modelo padrão atualizado.",
            life: 3000
          });
        }
      });

    },

    changeModeloPadraoMedico(modelo) {
      if (this.tipo_consulta) {
        this.perfil["id_modelo_padrao_" + ( this.tipo_consulta_nome == 'revisão' ? 'revisao' : this.tipo_consulta_nome )] =
          modelo.id_modelo_prontuario;

        this.$util.atualizar(this, {
          service: "medico_unidades",
          dados: this.perfil,
          callback: () => {
            this.padrao = modelo.id_modelo_prontuario;

            this.$toast.add({
              severity: "success",
              summary: "Atenção",
              detail: "Modelo padrão atualizado.",
              life: 3000
            });
          }
        });
      } else {
        this.$emit("definirModelo", modelo.id_modelo_prontuario);
        this.padrao = modelo.id_modelo_prontuario;
      }
    },
    printAnamnese() {
      this.$emit("imprimirAnamnese", this.value);

      // this.$parent.imprimirAnamnese(this.value);

      // let atendimento = this.$parent.atendimento;
      // console.log("value", this.value);
      // // let atdp_ = this.atdp;
      // this.$refs.printanamnese.imprimirAnamnese(atendimento, this.value);
    },

    load_info (force = false) { 

        if ( force || ( this.textos === null ) ) { 

            let query = { q: [] }; 

            if ( !this.is_preatendimento ) { 
                query.q.push({
                    name: "modelos.index",
                    id: "modelos",
                    parms: {
                    mode: "selecao",
                    id_procedimento: this.id_procedimento,
                    id_atendimento: this.id_atendimento, 
                    where: { fl_ativo: true }
                    }
                });

                query.q.push({
                    name: "medico_unidades.index",
                    id: "perfil",
                    parms: {
                    usuario_logado: true
                    }
                });
            }

            if ( this.id_atendimento ) { 
                query.q.push({ 
                    name: 'textos_padrao.index',
                    id: 'textos', 
                    parms: { 
                        id_atendimento: this.id_atendimento, 
                        id_procedimento: this.id_procedimento, 
                        pre_atendimento: this.is_preatendimento ? true : false,
                    }
                });
            }

            if ( query.q.length ) { 

                this.axios.post("/aql", query).then(res => {
                    if (res.data.modelos && res.data.modelos.status == 200) {
                        this.modelos = res.data.modelos.data;

                        if (this.modeloPadrao) {
                            let item = this.modelos.find(modelo => {
                                return modelo.id_modelo_prontuario == this.modeloPadrao;
                            });

                            if (item) {
                                this.modelo = item;
                            }
                        }
                    }

                    if (res.data.perfil && res.data.perfil.status == 200) {
                        if (res.data.perfil.data.length == 1) {
                            this.perfil = res.data.perfil.data[0];

                            this.definir_padrao_pelo_perfil();

                            this.$nextTick(() => {
                                $('[data-toggle="tooltip"]').tooltip();
                            });
                        }
                    }

                    if (res.data.textos && res.data.textos.status == 200) {
                        this.textos = res.data.textos.data;
                    }
                });

            }

        }

    }

  },

  mounted() {
    console.log('mounted pre', this.is_preatendimento);
    if (this.mode != "view" && ( this.mode != "fixed" || this.block_modelos === false || this.is_preatendimento ) && !this.block_modelos) {
        this.load_info(true); 

        /*
        let query = { q: [] }; 

        if ( !this.is_preatendimento ) { 
            query.q.push({
                name: "modelos.index",
                id: "modelos",
                parms: {
                mode: "selecao",
                id_procedimento: this.id_procedimento,
                id_atendimento: this.id_atendimento, 
                where: { fl_ativo: true }
                }
            });

            query.q.push({
                name: "medico_unidades.index",
                id: "perfil",
                parms: {
                usuario_logado: true
                }
            });
        }

        if ( this.id_atendimento ) { 
            query.q.push({ 
                name: 'textos_padrao.index',
                id: 'textos', 
                parms: { 
                    id_atendimento: this.id_atendimento, 
                    id_procedimento: this.id_procedimento, 
                    pre_atendimento: this.is_preatendimento ? true : false,
                }
            });
        }

        if ( query.q.length ) { 

            this.axios.post("/aql", query).then(res => {
                if (res.data.modelos && res.data.modelos.status == 200) {
                    this.modelos = res.data.modelos.data;

                    if (this.modeloPadrao) {
                        let item = this.modelos.find(modelo => {
                            return modelo.id_modelo_prontuario == this.modeloPadrao;
                        });

                        if (item) {
                            this.modelo = item;
                        }
                    }
                }

                if (res.data.perfil && res.data.perfil.status == 200) {
                    if (res.data.perfil.data.length == 1) {
                        this.perfil = res.data.perfil.data[0];

                        this.definir_padrao_pelo_perfil();

                        this.$nextTick(() => {
                            $('[data-toggle="tooltip"]').tooltip();
                        });
                    }
                }

                if (res.data.textos && res.data.textos.status == 200) {
                    this.textos = res.data.textos.data;
                }
            });

        }
        */

    }

  }

}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>